<template>
    <!-- Dialog / Card are auto-registered via unplugin-vue-components (PrimeVueResolver). -->
    <Dialog
        v-model:visible="visible"
        modal
        :closable="false"
        :close-on-escape="false"
        :style="{ width: '400px' }"
        :pt="{ mask: { class: 'backdrop-blur-sm' } }">
        <template #container>
            <Card>
                <template #content>
                    <div class="text-center p-4">
                        <div class="text-xl">{{ message }}</div>
                        <RotatingLogo class="mt-4" />
                    </div>
                </template>
            </Card>
        </template>
    </Dialog>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import RotatingLogo from "@/components/RotatingLogo.vue";
import { useProcessingOverlayStore } from "@/stores/processingOverlay";

const { visible, message } = storeToRefs(useProcessingOverlayStore());
</script>
